<template>
  <div class="savior">
    <div class="header">
      <div class="description" v-html="text.header[viewType]"></div>
      <div class="play-btn" @click="playFree"></div>
      <div class="patch-notes-btn patch242" @click="patchNotes242"></div>
      <div class="patch-notes-btn patch243" @click="patchNotes243"></div>
    </div>
    <div class="content_frame"></div>
    <div class="content">
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Guild Castle" class="section guild-castle">
        <div class="title"></div>
        <div class="description" v-html="text.guildcastle[viewType]"></div>
        <div class="carousel">
          <carousel ref="guildCastleCarousel" :items-to-show="1" :autoplay="2000" :transition="1000" :pause-autoplay-on-hover="true" :wrap-around="true">
            <slide :key="0"><img :src="require('@/assets/images/microsites/savior/guild-castle/carousel/preview_01.png')" /></slide>
            <slide :key="1"><img :src="require('@/assets/images/microsites/savior/guild-castle/carousel/preview_02.png')" /></slide>
            <template #addons>
              <Pagination />
            </template>
          </carousel>
          <div class="carousel-bottom"></div>
        </div>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Shangri-La" class="section shangri-la">
        <div class="title"></div>
        <div class="description" v-html="text.shangrila[viewType]"></div>
        <div class="carousel">
          <carousel ref="shangriLaCarousel" :items-to-show="1" :autoplay="2000" :transition="1000" :pause-autoplay-on-hover="true" :wrap-around="true">
            <slide :key="0"><img :src="require('@/assets/images/microsites/savior/shangri-la/carousel/preview_01.png')" /></slide>
            <slide :key="1"><img :src="require('@/assets/images/microsites/savior/shangri-la/carousel/preview_02.png')" /></slide>
            <slide :key="2"><img :src="require('@/assets/images/microsites/savior/shangri-la/carousel/preview_03.png')" /></slide>
            <template #addons>
              <Pagination />
            </template>
          </carousel>
          <div class="carousel-bottom"></div>
        </div>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Kaling" class="section three-perils">
        <div class="title"></div>
        <div class="description" v-html="text.threeperils[viewType]"></div>
        <div class="carousel">
          <carousel ref="threePerilsCarousel" :items-to-show="1" :autoplay="2000" :transition="1000" :pause-autoplay-on-hover="true" :wrap-around="true">
            <slide :key="0"><img :src="require('@/assets/images/microsites/savior/three-perils/carousel/preview_01.png')" /></slide>
            <slide :key="1"><img :src="require('@/assets/images/microsites/savior/three-perils/carousel/preview_02.png')" /></slide>
            <slide :key="2"><img :src="require('@/assets/images/microsites/savior/three-perils/carousel/preview_03.png')" /></slide>
            <slide :key="3"><img :src="require('@/assets/images/microsites/savior/three-perils/carousel/preview_04.png')" /></slide>
            <template #addons>
              <Pagination />
            </template>
          </carousel>
          <div class="carousel-bottom"></div>
        </div>
      </div>
      <div class="divider"></div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Khali" class="section wind-vengeance">
        <div class="title"></div>
        <div class="khali"></div>
        <div class="description" v-html="text.windvengeance[viewType]"></div>
        <div class="stats"></div>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Abilities" class="section abilities">
        <div class="title"></div>
        <div class="skills">
          <div>
            <div></div>
            <div></div>
            <div v-html="text.skills[0][viewType]"></div>
          </div>
          <div>
            <div></div>
            <div></div>
            <div v-html="text.skills[1][viewType]"></div>
          </div>
          <div>
            <div></div>
            <div></div>
            <div v-html="text.skills[2][viewType]"></div>
          </div>
          <div>
            <div></div>
            <div></div>
            <div v-html="text.skills[3][viewType]"></div>
          </div>
        </div>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Wongstaurant" class="section wongstaurant">
        <div class="title"></div>
        <div class="description" v-html="text.wongstaurant[viewType]"></div>
        <div class="wongstaurant"></div>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Arcane river" class="section arcane-river">
        <div class="title"></div>
        <div class="description" v-html="text.arcaneriver[viewType]"></div>
        <div class="carousel">
          <carousel ref="arcaneRiverCarousel" :items-to-show="1" :autoplay="2000" :transition="1000" :pause-autoplay-on-hover="true" :wrap-around="true">
            <slide :key="0"><img :src="require('@/assets/images/microsites/savior/arcane-river/carousel/preview_01.png')" /></slide>
            <slide :key="1"><img :src="require('@/assets/images/microsites/savior/arcane-river/carousel/preview_02.png')" /></slide>
            <slide :key="2"><img :src="require('@/assets/images/microsites/savior/arcane-river/carousel/preview_03.png')" /></slide>
            <slide :key="3"><img :src="require('@/assets/images/microsites/savior/arcane-river/carousel/preview_04.png')" /></slide>
            <template #addons>
              <Pagination />
            </template>
          </carousel>
          <div class="carousel-bottom"></div>
        </div>
        <div class="list">
          <ul>
            <li v-html="text.arcaneriver.list[0][viewType]"></li>
            <li v-html="text.arcaneriver.list[1][viewType]"></li>
            <li v-html="text.arcaneriver.list[2][viewType]"></li>
            <li><strong>And More!</strong></li>
          </ul>
        </div>
        <span class="arrival">Available Now!</span>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Hyper burning and burning world" class="section hyper-burning-world">
        <div class="title"></div>
        <div class="description" v-html="text.hyperburningworld[viewType]"></div>
        <div class="hyper-burning"></div>
      </div>
      <div v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Better maple" class="section better-maple">
        <div class="title"></div>
        <div class="description" v-html="text.bettermaple[viewType]"></div>
        <div class="characters"></div>
        <div class="list">
          <ul>
            <li v-html="text.bettermaple.list[0][viewType]"></li>
            <li v-html="text.bettermaple.list[1][viewType]"></li>
            <li v-html="text.bettermaple.list[2][viewType]"></li>
            <li><strong>And More!</strong></li>
          </ul>
        </div>
        <span class="arrival">Available Now!</span>
      </div>
    </div>
    <div class="footer">
        <Footer color="#e1b966" hoverColor="white" backgroundColor="#322e19"/>
    </div>
  </div>
</template>

<script>
import '@/assets/scss/microsites/savior/_savior.scss'
import Responsive from '@/services/browser/Responsive';
import Util from '@/services/browser/Util';
import Cookie from '@/services/browser/Cookie';
import Footer from '@/components/microsites/Footer.vue';
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import TEXT from './text';

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  name: 'Microsite Savior',
  components: {
    Carousel,
    Slide,
    Pagination,
    Footer,
  },
  props: {},
  data() {
    return {
      clientWidth: 0,
      text: TEXT,
    }
  },
  computed: {
    viewType() {
      return this.clientWidth > 1024 ? 'desktop' : 'mobile';
    },
    observeVisibilityDataLayerSettings() {
      return {
        callback: this.checkVisibility,
        intersection: {threshold: 0.3},
        throttle: 2000,
        once: true
      }
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    Cookie.set("maplesavior", "true");
    Responsive.init();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.carouselTracking();
  },
  methods: {
    carouselTracking() {
      for (let ref in this.$refs) {
        const carousel = this.$refs[ref].$el;
        const pageButtons = carousel.getElementsByClassName('carousel__pagination-button');
        for (let i = 0; i < pageButtons.length; i++) {
          let pageButton = pageButtons[i];
          if (pageButton) pageButton.addEventListener('mouseup', () => this.clickTracking(`${this.getCarouselTrackingName(ref)} > image${i + 1}`));
        }
      }
    },
    getCarouselTrackingName(carousel) {
      let name = carousel;
      switch (carousel) {
        case 'guildCastleCarousel':
          name = 'Guild castle Carousel';
          break;
        case 'shangriLaCarousel':
          name = 'Shangri-La carousel';
          break;
        case 'threePerilsCarousel':
          name = 'Kaling carousel';
          break;
        case 'arcaneRiverCarousel':
          name = 'Arcane river carousel';
          break;
        default:
          name = carousel;
      }
      return name;
    },
    handleResize() {
      this.clientWidth =
        document.body.clientWidth ||
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.updateCarousels();
    },
    updateCarousels() {
      if (!this.$refs) return;
      setTimeout(() => {
        for (let ref in this.$refs) {
          const carousel = this.$refs[ref];
          if (carousel) carousel.updateSlideWidth();
        }
      }, 250);
    },
    playFree(){
      Util.playFree();
      this.clickTracking('Play Free Button');
    },
    patchNotes242() {
      this.clickTracking('V242 Patch Notes');
      window.open('http://maplestory.nexon.net/news/83731', '_blank');
    },
    patchNotes243() {
      this.clickTracking('V243 Patch Notes');
      window.open('http://maplestory.nexon.net/news/84616', '_blank');
    },
    handlePreSaviorLoginClick(e) {
      const clickedId = e.target.id;
      if (clickedId === 'Pre-savior_login_event') {
        this.clickTracking(clickedId.replaceAll('_', ' '));
      }
    },
    checkVisibility(isVisible, entry) {
      if (isVisible) {
        this.viewTracking(entry.target.dataset.id);
      }
    },
    clickTracking(element) {
      window.dataLayer.push({
        event: 'Transition Event',
        ec: 'Savior Microsite Phase 2',
        ea: 'click',
        el: element,
      })
    },
    viewTracking(element) {
      window.dataLayer.push({
        event: 'Element View',
        ec: 'Savior Microsite Phase 2',
        ea: 'view',
        el: element,
        noninteraction: true,
      });
    },
  },
})
</script>
